import { render, staticRenderFns } from "./wiki.vue?vue&type=template&id=302acdf2&scoped=true"
import script from "./wiki.vue?vue&type=script&lang=js"
export * from "./wiki.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302acdf2",
  null
  
)

export default component.exports